import React, { Component } from 'react';
import { Button, Card, Table, Pagination, message, Modal } from 'antd';
// import { UnorderedListOutlined } from '@ant-design/icons';
import SearchCriteria from '../../components/SearchCriteria/SearchCriteria';
import axios from 'axios';
import baseConfig from '../../config/BaseConfig';
import moment from 'moment';
import './ConsumeRecord.less';

/* 消费记录 */
export default class ConsumeRecord extends Component {

    state = {
        list: [],
        currentPage: 1,
        count: 1,
        detailModalVisible: false,
        detailList: [],
        tableLoading: false
    };

    // 搜索条件数值
    seacrhParam = {
        date_range: [],
        start_time: '',
        end_time: '',
    };

    // 搜索条件组件初始数据
    seacrhItems = [
        { title: '消费时间', inputType: 'date_range', seacrhType: 'date_range', span: 6 },
        { title: '', inputType: 'buttons', seacrhType: '', children: [{ title: '搜索', key: 'submit' }, { title: '导出', key: 'export' }] },
    ]

    // 列表项
    columns = [
        {
            title: '课程名称',
            dataIndex: 'course_name',
            align: 'center',
            width: 200,
        },
        // {
        //     title: '课程ID',
        //     dataIndex: 'course_id',
        //     align: 'center',
        //     width: 100,
        // },
        {
            title: '学生姓名',
            dataIndex: 'student_name',
            align: 'center',
            width: 100,
        },
        {
            title: '教师姓名',
            dataIndex: 'teacher_name',
            align: 'center',
            width: 100,
        },
        {
            title: '金额',
            dataIndex: 'price',
            align: 'center',
            width: 100,
        },
        {
            title: '时间',
            dataIndex: 'log_time',
            align: 'center',
            width: 200,
        },
        // {
        //     title: '消费数量',
        //     dataIndex: 'count',
        //     align: 'center',
        //     width: 100,
        // },
        // {
        //     title: '订单号',
        //     dataIndex: 'order_id',
        //     align: 'center',
        //     width: 200,
        // },
        // {
        //     title: '消费类型',
        //     dataIndex: 'product_name',
        //     align: 'center',
        //     width: 200,
        // },
        // {
        //     title: '备注',
        //     dataIndex: 'pay_type',
        //     align: 'center',
        //     width: 150,
        // },
        // {
        //     title: '操作',
        //     dataIndex: 'operator',
        //     align: 'center',
        //     width: 100,
        //     render: (text, record) => (
        //         <Space size="middle">
        //             <Tooltip title="查看">
        //                 <Button shape="circle" onClick={() => { this.consumeDetail(record) }}><UnorderedListOutlined /></Button>
        //             </Tooltip>
        //         </Space>
        //     )
        // },
    ];

    detailColumns = [
        {
            title: '账号类型',
            dataIndex: 'product_name',
            align: 'center',
            width: 200,
        },
        {
            title: '学生全名',
            dataIndex: 'full_name',
            align: 'center',
            width: 100,
        },
        {
            title: '学生登录名',
            dataIndex: 'login_name',
            align: 'center',
            width: 100,
        },
    ];

    // 组件挂载
    componentDidMount() {
        this.seacrhDataFun({ page: 1 });
    }

    // 导出
    exportDataFun = () => {
        let exportUrl = baseConfig.httpUrl + '/api/pay/consume-record?';

        let tempSeacrhParam = {};
        Object.assign(tempSeacrhParam, this.seacrhParam);
        delete tempSeacrhParam.date_range;

        for (let key in tempSeacrhParam) {
            if (tempSeacrhParam[key] !== undefined) {
                exportUrl += key + '=' + tempSeacrhParam[key] + '&'
            }
        }
        exportUrl += 'export=1'
        window.open(exportUrl, '_blank')
    }

    // 获取列表数据
    seacrhDataFun = (data = null) => {

        let tempParam = {};
        Object.assign(tempParam, this.seacrhParam);
        tempParam.page = this.state.currentPage;
        delete tempParam.date_range;

        if (data) {
            tempParam.page = data.page;
        }

        if (!tempParam.start_time) {
            delete tempParam.start_time;
        }
        if (!tempParam.end_time) {
            delete tempParam.end_time;
        }

        this.setState({ tableLoading: true });
        axios.get(baseConfig.httpUrl + `/api/pay/consume-record`, { params: tempParam }).then(
            response => {
                if (response.data.res == 1) {
                    const { data, page, count } = response.data;

                    data.map((dataObj) => {
                        return dataObj.key = dataObj.id
                    });

                    this.setState({
                        list: [...data],
                        currentPage: page * 1,
                        count: count,
                        tableLoading: false
                    });
                }
                else {
                    this.setState({
                        list: [],
                        currentPage: 1,
                        count: 1,
                        tableLoading: false
                    });
                    message.error({
                        content: response.data.msg,
                        className: 'custom-class',
                    });
                }
            },
            error => { }
        );
    }

    // 跟新搜索条件数值
    updateSeacrhItems = (seacrhData) => {
        let tempObj = this.formatParams(seacrhData);

        if (tempObj.date_range && tempObj.date_range.length == 2) {
            tempObj.start_time = moment(tempObj.date_range[0]).format('YYYY-MM-DD');
            tempObj.end_time = moment(tempObj.date_range[1]).format('YYYY-MM-DD');
        }
        else {
            tempObj.start_time = '';
            tempObj.end_time = '';
        }

        Object.assign(this.seacrhParam, tempObj);
    }

    // 格式化参数
    formatParams = (seacrhParam) => {
        for (let key in seacrhParam) {
            seacrhParam[key] = seacrhParam[key] == undefined ? '' : seacrhParam[key];
        }
        return seacrhParam;
    }

    // 换页
    changePage = (pageNum, pageSize) => {
        this.seacrhDataFun({ page: pageNum });
    }

    // 消费详情
    consumeDetail = (data) => {
        axios.get(baseConfig.httpUrl + '/api/pay/consume-detail', { params: { order_id: data.order_id } }).then(
            response => {
                if (response.data.res == 1) {

                    response.data.data.map((tempObj) => {
                        tempObj.key = tempObj.user_guid;
                        return true;
                    })

                    this.setState({
                        detailModalVisible: true,
                        detailList: [...response.data.data]
                    })
                }
                else {
                    message.error(response.data.msg);
                }
            }
        );

    }

    // 关闭详情
    detailCancel = () => {
        this.setState({ detailModalVisible: false, })
    }

    render() {
        return (
            <Card title="" style={{ minHeight: '100%' }} className='ConsumeRecord'>
                {/* 删除测评记录 */}
                <Modal
                    className='modals ConsumeRecord-modals'
                    title="消费详情"
                    visible={this.state.detailModalVisible}
                    onCancel={this.detailCancel}
                    maskClosable={false}
                >
                    <Table
                        dataSource={this.state.detailList}
                        pagination={false}
                        columns={this.detailColumns}
                        loading={this.state.tableLoading}
                    >
                    </Table>
                </Modal>

                {/* 搜索条件 */}
                <div>
                    <SearchCriteria
                        seacrhItems={this.seacrhItems}
                        exportFun={this.exportDataFun}
                        seacrhFun={this.seacrhDataFun}
                        updateSeacrhValue={this.updateSeacrhItems}
                    />
                </div>

                {/* 列表 */}
                <Table
                    dataSource={this.state.list}
                    pagination={false}
                    columns={this.columns}
                >
                </Table>

                {/* 分页 */}
                <Pagination
                    onChange={this.changePage}
                    style={{ marginTop: 30 }}
                    defaultCurrent={1}
                    current={this.state.currentPage}
                    total={this.state.count}
                    hideOnSinglePage={true}
                    showQuickJumper={{
                        goButton: <span><span>&nbsp;&nbsp;&nbsp;&nbsp;</span> <Button type='primary'>Go</Button></span>,
                    }}
                    showTotal={(total, range) => `当前显示${range[0]}-${range[1]}条  共${total}条记录 `}
                    showSizeChanger={false}
                />
            </Card >
        )
    }
}
